import { favoriteListQueryKeys as e } from "./favoriteListQueryKeys.mjs";
import { onboardingQueryKeys as t } from "../onboarding/useOnboardingQueryKeys.mjs";
import { propertyQueryKeys as n } from "../properties/usePropertiesQueryKeys.mjs";
import { useMutation as r, useQueryClient as i } from "@maat/store-hooks";
import { favoriteListsApi as a } from "@maat/api-main";
//#region src/favoriteLists/useAddListingToFavoriteMutation.ts
var o = () => {
	let o = i();
	return r({
		mutationFn: ({ listId: e, listingId: t }) => a.addListing(e, t),
		onSuccess: (r, { listId: i }) => {
			o.invalidateQueries({ queryKey: e.list() }), o.invalidateQueries({ queryKey: e.feed() }), o.invalidateQueries({ queryKey: e.detail(i) }), o.invalidateQueries({ queryKey: t.status() }), o.invalidateQueries({ queryKey: n.guestHomePersonal() });
		}
	});
};
//#endregion
export { o as useAddListingToFavoriteMutation };
